export default __webpack_public_path__ + "static/underline-18-567337f7acb6c49c4b8befc7fe35f2c2.svg";